class DiscountPopup extends HTMLElement {
  constructor() {
    super();
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleApply = this.handleApply.bind(this);
    this.handleCopy = this.handleCopy.bind(this);

    this.popup = this.querySelector('div[data-popup]');
    this.closeButton = this.querySelector('button[name="close"]');
    this.copyButtons = this.querySelectorAll('button[data-copy-discount]');
    this.applyButtons = this.querySelectorAll('button[data-apply-discount]');
    this.primaryButton = this.querySelector('button[data-primary-button]');
    this.secondaryButton = this.querySelector('button[data-secondary-button]');
  }

  connectedCallback() {
    window.addEventListener('block-discount-picker:open', this.handleOpen);
    this.closeButton.addEventListener('click', this.handleClose);
    this.secondaryButton.addEventListener('click', this.handleClose);
    for (let i = 0; i < this.applyButtons.length; i++) {
      const applyButton = this.applyButtons[i];
      const discountCode = applyButton.getAttribute('data-discount');
      applyButton.addEventListener('click', () => {
        this.handleApply(discountCode);
      });
    }
    for (let i = 0; i < this.copyButtons.length; i++) {
      const copyButton = this.copyButtons[i];
      const discountCode = copyButton.getAttribute('data-discount');
      copyButton.addEventListener('click', () => {
        this.handleCopy(discountCode);
      });
    }
  }

  disconnectedCallback() {
    window.removeEventListener('block-discount-picker:open', this.handleOpen);
    this.closeButton.removeEventListener('click', this.handleClose);
    this.secondaryButton.removeEventListener('click', this.handleClose);
    for (let i = 0; i < this.applyButtons.length; i++) {
      applyButton.removeEventListener('click');
    }
  }

  handleOpen() {
    this.popup.classList.remove('invisible');
  }

  handleClose() {
    this.popup.classList.add('invisible');
  }

  handleApply(discountCode) {
    window.discountOnCartProApp.applyCode(discountCode);
    this.handleClose();
  }

  handleCopy(code) {
    navigator.clipboard.writeText(code);
  }
}

customElements.define('discount-popup', DiscountPopup);

class DiscountPicker extends HTMLElement {
  constructor() {
    super();
    this.handleOpen = this.handleOpen.bind(this);
    this.openButton = this.querySelector('a[data-discount-popup-open]');
  }

  connectedCallback() {
    this.openButton.addEventListener('click', this.handleOpen);
  }

  disconnectedCallback() {
    this.openButton.removeEventListener('click', this.handleOpen);
  }

  handleOpen() {
    const event = new CustomEvent('block-discount-picker:open', {});
    window.dispatchEvent(event);
  }
}

customElements.define('discount-picker', DiscountPicker);
